import type { RootState } from '/business/shared/state/store';

export default (state: RootState) => {
  const appId = state.applications?.activeApplicationId || null;
  if (appId !== null) {
    return parseInt(appId, 10);
  }
  return null;
};
